import { FC, ReactNode } from 'react'

import styled from 'styled-components'
import { Dayjs } from 'dayjs'

import {
  CampaignPlatformTypeEnum,
  SpotifyCampaignMatchingType,
} from 'src/Types/campaigns'
import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'

import { ScheduleSettingsHeaderTrackDetails } from './ScheduleSettingsHeaderTrackDetails'
import { ScheduleSettingsHeaderTime } from './ScheduleSettingsHeaderTime'

const Container = styled.div`
  display: flex;
  padding: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  border-radius: 16px;
  border: 1px solid ${(props) => props.theme.color.lightGrey};
  background-color: ${(props) => props.theme.color.white};
  box-shadow: ${({ theme }) => theme.shadow.card};
  @media screen and (min-width: ${MAX_MOBILE_WIDTH}) {
    flex-direction: row;
  }
`

export interface ScheduleSettingsHeaderProps {
  trackCover?: string
  trackName?: string
  todayEnable?: boolean
  artistName?: string
  startDate?: Dayjs | ReactNode
  platform: CampaignPlatformTypeEnum
  onChangeDate?: (date: Dayjs) => void
  isEditable?: boolean
  matchingType?: SpotifyCampaignMatchingType | null
  isPreRelease?: boolean
}

export const ScheduleSettingsHeader: FC<ScheduleSettingsHeaderProps> = (
  props,
) => {
  const {
    trackCover,
    platform,
    artistName,
    trackName,
    startDate,
    todayEnable,
    onChangeDate,
    isEditable,
    matchingType,
    isPreRelease,
  } = props
  const isTimeVisible = Boolean(startDate) || Boolean(isEditable)

  return (
    <Container>
      <ScheduleSettingsHeaderTrackDetails
        trackCover={trackCover}
        trackName={trackName}
        artistName={artistName}
        platform={platform}
        matchingType={matchingType}
        isPreRelease={isPreRelease}
      />
      {isTimeVisible && (
        <ScheduleSettingsHeaderTime
          onChangeDate={onChangeDate}
          todayEnable={todayEnable}
          startDate={startDate}
          isEditable={isEditable}
        />
      )}
    </Container>
  )
}
